module.exports = __webpack_public_path__ + "img/main-mobile.7c8b1659.webp";